export default __webpack_public_path__ + "static/media/wall street_icon.f15781e1.svg";